"use strict";
var typestyle_1 = require("typestyle");
var kaavioBackgroundColor = 'white';
var kaavioColor = 'black';
exports.globalClass = typestyle_1.style({
    fontFamily: 'Roboto',
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden'
});
exports.containerClass = typestyle_1.style({
    color: kaavioColor,
    backgroundColor: kaavioBackgroundColor,
    width: '100%',
    height: '100%'
});
exports.diagramClass = typestyle_1.style({
    backgroundColor: kaavioBackgroundColor,
    width: '100%',
    height: '100%'
});
exports.viewportClass = typestyle_1.style((_a = {},
    _a[".kaavio-viewport-background"] = {
        fill: kaavioBackgroundColor,
    },
    _a["text"] = {
        fontSize: '12px',
        pointerEvents: 'none',
        strokeWidth: '0px',
    },
    _a));
exports.CellularComponentClass = typestyle_1.style((_b = {},
    _b[" .Icon"] = {
        clipPath: 'none',
        fill: 'transparent',
        stroke: '#808080',
        strokeWidth: 3,
    },
    _b));
exports.DataNodeClass = typestyle_1.style((_c = {},
    _c[" .Icon"] = {
        clipPath: 'url(#rounded-rectangle-clip-path)',
        fill: '#2BDA82',
        strokeWidth: '0px',
    },
    _c[" .textlabel"] = {
        fill: '#fff',
    },
    _c[" .Highlighted"] = {
        opacity: 0.6,
        clipPath: 'url(#rounded-rectangle-clip-path)',
        strokeWidth: '0px'
    },
    _c["&.Rna"] = (_d = {},
        _d["& .Icon"] = {
            fill: '#9453A7',
        },
        _d),
    _c["&.Metabolite"] = (_e = {},
        _e["& .Icon"] = {
            clipPath: 'none',
            fill: '#0099FF',
        },
        _e["& .Highlighted"] = {
            clipPath: 'none'
        },
        _e),
    _c["&.Pathway"] = (_f = {},
        _f["& .Icon"] = {
            clipPath: 'none',
            fill: kaavioBackgroundColor,
            // NOTE: Uncomment the line below to see an example
            // of adding a dropshadow to Pathway DataNodes:
            /*filter: 'drop-shadow( 2px 2px 2px #000 )', */
            strokeWidth: '0px',
        },
        _f["& .textlabel"] = {
            fill: '#75C95C',
        },
        _f["& .Highlighted"] = {
            clipPath: 'none'
        },
        _f),
    _c));
exports.LabelClass = typestyle_1.style((_g = {},
    _g[" .Icon"] = {
        clipPath: 'url(#rounded-rectangle-clip-path)',
        stroke: 'transparent',
        strokeWidth: '0px',
        fill: 'transparent',
    },
    _g[" .textlabel"] = {
        fill: '#444',
    },
    _g));
exports.StateClass = typestyle_1.style({
    fill: '#009999',
    stroke: '#fff',
    strokeWidth: 1,
});
exports.GroupGroupClass = typestyle_1.style({
    fill: 'transparent',
    strokeWidth: '0px',
});
exports.GroupComplexClass = typestyle_1.style((_h = {},
    _h["& > .Icon"] = {
        fill: '#B4B464',
        fillOpacity: 0.1,
        stroke: '#808080',
    },
    _h));
exports.GroupNoneClass = typestyle_1.style((_j = {},
    _j["& > .Icon"] = {
        fill: '#B4B464',
        fillOpacity: 0.1,
        stroke: '#808080',
    },
    _j));
exports.GroupPathwayClass = typestyle_1.style((_k = {},
    _k["& > .Icon"] = {
        fill: '#008000',
        fillOpacity: 0.05,
        stroke: '#808080',
    },
    _k));
exports.InteractionClass = typestyle_1.style({
    stroke: '#000000',
});
exports.InhibitionClass = typestyle_1.style({
    stroke: 'red',
    strokeWidth: 1.3,
});
exports.CitationClass = typestyle_1.style((_l = {},
    _l[" .Icon"] = {
        fill: 'none',
        strokeWidth: '0px',
    },
    _l[" .textlabel"] = {
        fill: 'gray',
        fontSize: '10px',
    },
    _l));
exports.InfoBoxClass = typestyle_1.style((_m = {
        fill: '#444'
    },
    _m["" + exports.CitationClass] = {
        fontSize: '0px',
    },
    _m));
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/WikiPathways.style.js
// module id = 479
// module chunks = 0